{
  "data_driven": {
    "formula_applied": "Formula applied",
    "by_attributes": "By attributes",
    "any_others": "Any Others"
  },
  "styles2": {
    "bold": "Bold",
    "regular": "Regular",
    "on": "On",
    "off": "Off",
    "arrow_spacing": "Arrow spacing",
    "arrow_colour": "Arrow colour",
    "arrow_size": "Arrow size",
    "arrow_opacity": "Arrow opacity",
    "rotation": "Rotation",
    "rotate_icon": "Rotate icon",
    "orientation_3d": "3D orientation",
    "flat": "Flat",
    "raised": "Raised",
    "degrees": "Degrees",
    "model": "Model",
    "type": "Type",
    "scale": "Scale",
    "choose_model": "Choose Model",
    "error_loading_models": "There was an error loading the 3d models",
    "solid": "Solid",
    "dashed": "Dashed",
    "type_of_line": "Type of line",
    "Line": "Line",
    "Area": "Area",
    "Point": "Point",
    "Icon": "Icon",
    "Model": "Model",
    "LineModel": "Line of 3D models",
    "AreaModel": "Area of 3D models",
    "spacing": "Spacing",
    "plural": {
      "Icon": "Icons",
      "Point": "Points"
    }
  },
  "object": {
    "deleteTitle": "Delete selected object(s)",
    "deleteDescription": "Are you sure you want to delete the selected object(s)?",
    "deleteToast": "{{ count }} objects deleted",
    "multiple": "Multiple",
    "multiple_objects": "Multiple objects"
  },
  "controls": {
    "draw": "Draw",
    "copy": "Copy",
    "select": "Select (Active layers)",
    "area_select": "Select (All layers)",
    "area_select_invalid": "The area drawn needs to have 3 or more points to be valid",
    "analysis": "Analysis",
    "search": "Search",
    "grab": "Grab",
    "toggle_3d_terrain": "3D terrain",
    "toggle_globe": "Globe view",
    "toggle_3d_buildings": "3D buildings",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out",
    "reset": "Reset view",
    "vr": "Digital Twin",
    "comments": "Comments",
    "calendar": "Calendar",
    "zoom_to_all_objects": "Zoom to all objects",
    "no_objects_to_zoom": "No visible objects on plan",
    "bookmarks": "Bookmarks"
  },
  "analysis": {
    "analysis_title": "Analysis tools",
    "distance_title": "Distance",
    "distance_description": "Measure the distance along a line",
    "distance_content": {
      "title": "Total distance of reference line on map"
    },
    "walk_time_title": "Walk time",
    "walk_time_description": "Calculate walk time along a line",
    "walk_time_content": {
      "title": "Total journey time when walking",
      "approx_time": "Approx. {{ speed }} minutes at",
      "m_per_second": "m/second"
    },
    "flow_rate_title": "Flow rate",
    "flow_rate_description": "Calculated flow of people through a gate (line drawn on the map)",
    "flow_rate_content": {
      "total_width": "Total width of gate (length of line)",
      "per_minute_per_hour": "{{ perMinute }} per minute / {{ perHour }} per hour",
      "at": "at",
      "people_meter_minute": "people / metre / minute",
      "fruin_service_levels": "Fruin service levels"
    },
    "area_title": "Area",
    "area_description": "Measure area within a shape on the map",
    "area_content": {
      "title": "Total area of reference polygon on map"
    },
    "capacity_content": {
      "total_area": "Total area",
      "per_m_sq": "{{ perMSq }} per m²",
      "at": "at",
      "people_meter_sq": "m² / person",
      "people_ft_sq": "ft² / person",
      "fruin_service_levels": "Fruin service levels"
    },
    "capacity_title": "Capacity",
    "capacity_description": "Calculate the holding capacity (people) of an area on the map",
    "count_title": "Count",
    "count_description": "Count the objects within an area on the map",
    "count_content": {
      "total": "Total",
      "current_level": "Current Level",
      "all_levels": "All Levels"
    }
  },
  "styles": {
    "line_fill": "Line Fill",
    "colour": "Colour",
    "colours": "Colours",
    "opacity": "Opacity",
    "blur": "Blur",
    "measurement": "Measurement",
    "width": "Width",
    "offset": "Offset",
    "join_and_end": "Ends and Joins",
    "join": "Joins",
    "end": "Ends",
    "arrows": "Arrows",
    "line_terminator_icon": "Line end icon(s)",
    "line_terminator_icon_start": "Start",
    "line_terminator_icon_end": "End",
    "line_terminator_icon_both": "Both",
    "text": "Text",
    "text_colour": "Text colour",
    "text_font": "Text font",
    "text_weight": "Text weight",
    "text_size": "Text size",
    "text_overlap": "Text overlap",
    "allow_text_overlap": "Show all",
    "no_text_overlap": "Combine",
    "text_outline_width": "Text outline width",
    "text_outline_colour": "Text outline colour",
    "text_opacity": "Text opacity",
    "text_content": "Text content",
    "outline": "Outline",
    "outline_type": "Outline Type",
    "outline_colour": "Outline colour",
    "outline_opacity": "Outline opacity",
    "outline_width": "Outline width",
    "outline_blur": "Outline blur",
    "no_colour": "No Colour",
    "company_palette": "Company Palette",
    "type_of_area": "Type of area",
    "area_2d": "2D area",
    "area_3d": "3D area",
    "height": "Height",
    "type_of_point": "Type of point",
    "point_fill": "Point fill",
    "radius": "Radius",
    "pitch_alignment": "3D Orientation",
    "area_fill": "Area Fill",
    "placement": "Placement",
    "pitch_alignment_map": "Flat",
    "pitch_alignment_viewport": "Raised",
    "pitch_alignment_map_desc": "{{ styleType }} lie flat on the map plane",
    "pitch_alignment_viewport_desc": "{{ styleType }} will always face the camera",
    "icon": "Icon",
    "icon_image": "Icon image",
    "icon_size": "Size",
    "icon_colour": "Colour",
    "icon_opacity": "Opacity",
    "rotation": "Rotation",
    "allow_overlap": "Icon overlap",
    "show_all": "Show all",
    "combine": "Combine",
    "choose_icon_image": "Choose icon image",
    "open_icon_selector": "Open icon selector",
    "spacing": "Spacing",
    "model_offset": "Model offset",
    "line_model_line_colour": "Line colour",
    "line_model_line_width": "Line width",
    "type": "Line type",
    "line_model_line_type": "Line type"
  }
}